import React from "react";
import { Row, Col } from "react-bootstrap";
import routes from "../../../../app/routes";

export default function Invoice({ invoice }) {
  return (
    <Col lg={6} className="rating-preview rate_5">
      <div className="ibox">
        <div className="ibox-content">
          <div className="logo">
            {invoice.attributes.paid && (
              <i className="fa fa-check green green-circle img-circle"></i>
            )}
          </div>
          <div className="media-body">
            <span className="user_name">
              <strong>Invoice </strong>
              {invoice.attributes.invoice_number}
            </span>
            <small className="date">
              Issued on {invoice.attributes.issued}
            </small>
            {invoice.attributes.paid && (
              <div className="green paid-status">Paid</div>
            )}
            {!invoice.attributes.paid && (
              <div className="orange paid-status">Unpaid</div>
            )}
            <div className="mt10 mr10">
              <Row>
                <Col sm={7}>
                  <div>{invoice.attributes.cycle.name}</div>
                  <div>
                    {invoice.attributes.cycle.form_format_cycle_start} -{" "}
                    {invoice.attributes.cycle.form_format_cycle_end}
                  </div>
                </Col>
                <Col sm={5}>
                  <dl className="dl-horizontal invoice">
                    <dt className="short">Total</dt>
                    <dd className="short">{invoice.attributes.invoice_total}</dd>
                  </dl>
                  <div className="text-right">
                    <a
                      href={invoice.attributes.report_url}
                      target="_blank"
                      className="btn btn-green"
                    >
                      Download PDF
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
}
